import { render, staticRenderFns } from "./proPriv.vue?vue&type=template&id=0b8f1dcf&scoped=true"
import script from "./proPriv.vue?vue&type=script&lang=js"
export * from "./proPriv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f1dcf",
  null
  
)

export default component.exports